import type { RouteStateTWC } from '@tmapy/types';

export const getRootRoute = (routes: RouteStateTWC[] | undefined, lang: string) => {
  return routes?.find((route) => {
    const path = typeof route.path === 'object' ? route.path[lang] : route.path;
    return path === '' || path === '/';
  });
};
